import { Resource } from '@ngxp/rest';
import { RegisterName } from '@schir-int-client/register-shared';
import { VerfahrenStatus, ZaehlblattAktionTyp } from '@schir-int-client/verfahren-shared';

export interface Statistik {
	SSR: StatistikEntry;
	SBR: StatistikEntry;
	BSR: StatistikEntry;
	AR: StatistikEntry;
	LFPR: StatistikEntry;
}

export interface StatistikEntry {
	ABGELEHNT: number;
	EINGETRAGEN: number;
	VORLAEUFIG: number;
	GELOESCHT: number;
}

export interface MonthlyStatistikEntry {
	datum: Date;
	register: RegisterName;
	[VerfahrenStatus.VORLAEUFIG]: number;
	[VerfahrenStatus.EINGETRAGEN]: number;
	[VerfahrenStatus.ABGELEHNT]: number;
	[VerfahrenStatus.GESCHLOSSEN]: number;
	[VerfahrenStatus.GELOESCHT]: number;
}

export interface MonthlyStatistik extends Resource {
	[RegisterName.SSR]: MonthlyStatistikEntry[];
	[RegisterName.BSR]: MonthlyStatistikEntry[];
	[RegisterName.SBR]: MonthlyStatistikEntry[];
	[RegisterName.AR]: MonthlyStatistikEntry[];
	[RegisterName.LR]: MonthlyStatistikEntry[];
}

export interface StatistikResource extends Statistik, Resource {}

export interface ZaehlblattColumn {
	header: string;
	count: Record<ZaehlblattAktionTyp, number>;
}

export interface ZaehlblattStatistik {
	data: ZaehlblattColumn[];
}

export interface ZaehlblattStatistikResource extends ZaehlblattStatistik, Resource {}

export enum VerfahrenAktionTyp {
	NEU = 'NEU',
	GESCHLOSSEN = 'GESCHLOSSEN',
	GELOESCHT = 'GELOESCHT',
}

export interface VerfahrenAktionStatistikRow {
	[RegisterName.SSR]: number;
	[RegisterName.BSR]: number;
	[RegisterName.SBR]: number;
	[RegisterName.LR]: number;
	[RegisterName.ETL]: number;
}

export interface VerfahrenAktionStatistik extends Resource {
	[VerfahrenAktionTyp.NEU]: VerfahrenAktionStatistikRow;
	[VerfahrenAktionTyp.GESCHLOSSEN]: VerfahrenAktionStatistikRow;
	[VerfahrenAktionTyp.GELOESCHT]: VerfahrenAktionStatistikRow;
}
